import { useState, MouseEvent } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { ChevronDownIcon, Link } from '@okta/odyssey-react-mui';
import { navigateTo } from '../../utils/Navigate';
import { useTranslation } from '@okta/tools.react-i18n';

const mappings = [
  { link: '/manual-activation', text: 'topBar.dropdown.appSubmission.manualActivation' },
  { link: '/rotate-app-info-secret', text: 'topBar.dropdown.appSubmission.rotateAppInfoSecret' },
];

export const AppSubmissionDropdown = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Link className="appSubmission-link" onClick={handleClick} sx={{ color: 'gray', cursor: 'pointer' }}>
        {t('topBar.dropdown.appSubmission.title')} <ChevronDownIcon />
      </Link>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {mappings.map(({ link, text }, index) => (
          <MenuItem key={index} onClick={() => navigateTo(link)}>
            {t(text)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
